import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/map1.jpg";
import projImg2 from "../assets/img/notes1.jpg";
import projImg3 from "../assets/img/pin1.jpg";
import projImg4 from "../assets/img/bubble1.webp";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
    title: "Travel Advisor App",
    description: "Using React",
    imgUrl: projImg1,
    githubUrl: "https://github.com/garimadixit80/travel_advisor_app",
  },
  {
    title: "Smart Notes App",
    description: "Using MERN stack And AIML",
    imgUrl: projImg2,
    githubUrl: "https://github.com/yourusername/smart-notes-app",
  },
  {
    title: "Pinterest Clone",
    description: "Using MERN stack",
    imgUrl: projImg3,
    githubUrl: "https://github.com/garimadixit80/pinterest-clone",
  },
  {
    title: "Bubble Game",
    description: "Using HTML, CSS and Javascript",
    imgUrl: projImg4,
    githubUrl: "https://github.com/garimadixit80/Bubble-Game",
  },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    
                    
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="section">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque quam, quod neque provident velit, rem explicabo excepturi id illo molestiae blanditiis, eligendi dicta officiis asperiores delectus quasi inventore debitis quo.</p>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=""></img>
    </section>
  )
}